import { createLoadingReducer } from './utils';

export default createLoadingReducer('AXEMA_SETTINGS');
